import { Component, OnInit } from '@angular/core';

import { WindowRef } from '../../window/service/window.service';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  constructor(private windowService: WindowRef) { }

  ngOnInit() {
  }

  back() {
    this.windowService.nativeWindow.history.back();
  }

  checkBack() {
    return (this.windowService.nativeWindow.document.referrer !== '') ? true : false;
  }
}
